<template>
  <el-container>
    <el-header class="table-header">
      <router-link :to="{name:'addOrg',path:'/addOrg'}">
        <el-button type="primary" size="small">{{$t('common.Add')}}</el-button>
      </router-link>
        <el-button icon="el-icon-search" align="center" size="small" @click="search('refresh')">{{$t('common.Search')}}</el-button>
        <el-button icon="el-icon-refresh-left" align="center" size="small" @click="resetForm()">{{$t('common.Reset')}}</el-button>
    </el-header>
    <el-container>
      <el-aside width="200px" class="aSide">
        <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"
                 :expand-on-click-node="false">
                 <span class="custom-tree-node" slot-scope="{ node, data }">
                   <span>
                     <img :src="menuFile">{{ node.label }}
                   </span>
                 </span>
                 </el-tree>
      </el-aside>
      <el-main class="table-main">
          <el-form :model="searchForm" label-width="80px" ref="searchForm" size="mini" class="table-form">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('common.Code')" prop="code">
                  <el-input v-model="searchForm.code"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('common.Name')" prop="name">
                  <el-input v-model="searchForm.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('base.info.org.Type')" prop="type">
                  <el-select v-model="searchForm.type">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="hidden" v-show="false">
                  <el-input v-model="searchForm.hidden"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table :data="tableData" highlight-current-row stripe border class='mb-10'>
            <el-table-column type="index" style="width: 10%">
            </el-table-column>
            <el-table-column prop="code" :label="$t('common.Code')" align="center">
            </el-table-column>
            <el-table-column prop="name" :label="$t('common.Name')" align="center">
            </el-table-column>
            <el-table-column prop="type" :label="$t('base.info.org.Type')" align="center">
            </el-table-column>
            <el-table-column prop="parentCode" :label="$t('base.info.org.Parent')" align="center">
            </el-table-column>
            <el-table-column prop="parentName" :label="$t('base.info.org.ParentName')" align="center">
            </el-table-column>
            <el-table-column prop="remark" :label="$t('common.Remark')" align="center">
            </el-table-column>
            <el-table-column prop="status" :label="$t('common.Status')" align="center" width="80%">
              <template slot-scope="scope">
                <span v-if="scope.row.status===50">{{$t('common.Normal')}}</span>
                <span v-if="scope.row.status===40">{{$t('common.Disable')}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('common.Operate')" width="150%" fixed="right">
              <template slot-scope="scope">
                <router-link :to="{path:'/updateOrg',name: 'updateOrg', params: {row:scope.row}}">
                  <el-button size="mini" type="text">{{$t('common.Edit')}}</el-button>
                </router-link>
                <el-button size="mini" v-if="scope.row.status===50" type="text" @click="disable(scope.row)">{{$t('common.Disable')}}</el-button>
                <el-button size="mini" v-if="scope.row.status===40" type="text" @click="resotre(scope.row)">{{$t('common.Recovery')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-footer class="table-footer">
            <table-page ref="orgListPage" :url="orgListUrl" :form="searchForm" @page-change="convert"></table-page>
          </el-footer>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Cookies from 'js-cookie'
import TablePage from '@/components/TablePage'

export default {
  data () {
    return {
      menuFile: './static/images/menuFile.png',
      tableData: [],
      orgListUrl: this.global.BASE_INFO + '/org/findByCondition',
      expandAll: false,
      options: [{
        label: '请选择'
      }, {
        value: '数据字典配置',
        label: '数据字典配置'
      }, {
        value: 'system_conf',
        label: 'system_conf'
      }, {
        value: 'org_type',
        label: 'org_type'
      }],
      pageInfo: {
        pageCount: 10, // 一页显示数目
        curIndex: 1, // 当前页数
        count: 100// 总条目数
      },
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      searchForm: {}
    }
  },
  components: {
    TablePage
  },
  methods: {
    resotre (row) {
      this.$confirm(this.$t('common.RecoverConfirm'), this.$t('common.Tips'), {
        confirmButtonText: this.$t('common.Ok'),
        cancelButtonText: this.$t('common.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.orgList.orgResumeByCode(this.qs.stringify({code: row.code}))
          .then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
            } else {
              this.$message({
                message: response.data.message,
                type: 'error'
              })
            }
            this.$refs['orgListPage'].getTableData()
          }).catch((error) => {
            console.log(error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('common.Cancel')
        })
      })
    },
    search (param) {
      this.$refs['orgListPage'].getTableData(param)
    },
    resetForm () {
      this.searchForm = {}
    },
    disable (row) {
      this.$confirm(this.$t('common.DisableConfirm'), this.$t('common.Tips'), {
        confirmButtonText: this.$t('common.Ok'),
        cancelButtonText: this.$t('common.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.orgList.orgDeleteByCode(this.qs.stringify({code: row.code}))
          .then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
            } else {
              this.$message({
                message: response.data.message,
                type: 'error'
              })
            }
            this.search()
          }).catch((error) => {
            console.log(error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('common.Cancel')
        })
      })
    },
    handleNodeClick (data) {
      this.orgListUrl = this.global.BASE_INFO + '/org/findByParentCode'
      this.searchForm = {code: data.code}
      this.$nextTick(() => {
        this.$refs['orgListPage'].getTableData()
      })
    },
    loadItem () {
      this.$api.orgList.findAll().then((response) => {
        this.data = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    convert (res) {
      this.tableData = res.data
    }
  },
  created () {
    this.loadItem()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/org/org.vue